import React from "react";
import ConfirmationModal from "../../../../../components/ConfirmationModal";

export default function LeaveWizardConfirmationModal({
  modalIsOpenState,
  onProceed,
}: {
  modalIsOpenState: [boolean, React.Dispatch<React.SetStateAction<boolean>>];
  onProceed: () => void;
}) {
  return (
    <ConfirmationModal
      modalIsOpenState={modalIsOpenState}
      headerText="Are you sure you want to leave this wizard?"
      bodyText="You will lose all progress and will have to start over."
      proceedButtonText="Proceed and discard progress"
      cancelButtonText="Back"
      onProceed={onProceed}
    />
  );
}
